/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbMetierAgrementGridDto
 */
export interface FcbMetierAgrementGridDto {
    /**
     * 
     * @type {string}
     * @memberof FcbMetierAgrementGridDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierAgrementGridDto
     */
    stade?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbMetierAgrementGridDto
     */
    accord?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FcbMetierAgrementGridDto
     */
    code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbMetierAgrementGridDto
     */
    idmetier?: number;
}

/**
 * Check if a given object implements the FcbMetierAgrementGridDto interface.
 */
export function instanceOfFcbMetierAgrementGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMetierAgrementGridDtoFromJSON(json: any): FcbMetierAgrementGridDto {
    return FcbMetierAgrementGridDtoFromJSONTyped(json, false);
}

export function FcbMetierAgrementGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMetierAgrementGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'stade': !exists(json, 'stade') ? undefined : json['stade'],
        'accord': !exists(json, 'accord') ? undefined : json['accord'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'idmetier': !exists(json, 'idmetier') ? undefined : json['idmetier'],
    };
}

export function FcbMetierAgrementGridDtoToJSON(value?: FcbMetierAgrementGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'libelle': value.libelle,
        'stade': value.stade,
        'accord': value.accord,
        'code': value.code,
        'idmetier': value.idmetier,
    };
}

